const getLanguage = () => {
    if (window.navigator.language.includes("nl")) {
        return "nl";
    } else {
        //return "en";
        return "nl";
    }
}

export default getLanguage;